import { genreService } from '@/libs/api'
import { groupByArrayOfObject } from '@/common/arrays'

const initialStates = {
    status: 'LOADING',
    genresList: [],
    pagination: {
        per_page: 15,
        current_page: 1,
        last_page: 1,
    },
    params: {
        page: 1
    }
}

const mutations = {
    loading(state) {
        state.status = 'LOADING'
    },
    setGenresList(state, genres) {
        state.status = 'SET_LIST'
        state.genresList = genres
    },
    setPagination(state, pagination) {
        state.status = 'SET_PAGINATION'
        state.pagination = Object.assign({}, state.pagination, pagination)
    },
    setParams(state, params) {
        state.status = 'SET_PARAMS'
        state.params = Object.assign({}, state.params, params)
    },
    createGenre(state, genre) {
        state.status = 'CREATE'
        state.genresList[genre.id] = genre
    },
    updateGenre(state, genre) {
        state.status = 'UPDATE'
        state.genresList[genre.id] = Object.assign({}, state.genresList[genre.id], genre)
    },
    deleteGenre(state, id) {
        state.status = 'DELETE_FROM_LIST'
        delete state.genresList[id]
    },
    error(state) {
        state.status = 'ERROR'
    }
}

const getters = {
    status: state => state.status,
    params: state => state.params,
    genres: state => state.genresList,
    pagination: state => state.pagination,
    genreById: state => id => state.genresList[id],
    selectableGenres: (state, getters) => {
        return Object.keys(getters.genres).map((id) => {
            return {
                value: getters.genres[id].id,
                label: getters.genres[id].title,
            }
        })
    }
}

const actions = {
    fetch({ commit, state }, params = {}) {
        params = Object.assign({}, state.params, params)

        commit('loading')

        return genreService.fetch(params).then(response => {
            let result = response.data
            const genres = groupByArrayOfObject(result.data, 'id')

            commit('setGenresList', genres)
            commit('setPagination', {
                per_page: result.per_page,
                current_page: result.current_page,
                last_page: result.last_page,
                total: result.total,
            })
            commit('setParams', {
                page: result.current_page,
            })
        })
    },

    create({ commit }, params = {}) {
        commit('loading')

        return new Promise((resolve, reject) => {
            genreService.create(params)
                .then(response => {
                    let result = response.data

                    commit('createGenre', result.data)
                    resolve(response.data)
                })
                .catch(error => {
                    commit('error')
                    reject(error.response.data)
                })
        })
    },

    edit({ commit }, params = {}) {
        commit('loading')

        return new Promise((resolve, reject) => {
            genreService.edit(params, params.id)
                .then(() => {
                    commit('updateGenre', params)
                    resolve()
                })
                .catch(error => {
                    commit('error')
                    reject(error.response.data)
                })
        })
    },

    delete({ commit }, id) {
        commit('loading')
        return new Promise((resolve, reject) => {
            genreService.delete(id)
                .then(() => {
                    commit('deleteGenre', id)
                    resolve()
                })
                .catch(error => {
                    commit('error')
                    reject(error)
                })
        })
    },
}

export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}